import React, { useEffect, useState }  from 'react';
import axios from "axios";
import Swal from 'sweetalert2'
import { useFormik } from 'formik';
import * as yup from 'yup';
import Modal from 'react-bootstrap/Modal';
import MultiSelectDropdown from '../Common/MultiSelectDropdown'

const validationSchema = yup.object({
    reportTitle: yup.string('Enter the report title').required('Report Title is required'),
});

export const Edit = ({ editId, assessmentId, show, setShow, ...rest}) => {
    const [competencies, setCompetencies] = useState([])
    const [selectedCompetencies, setSelectedCompetencies] = useState([])
    const [contents, setContents] = useState([])
    const [selectedContents, setSelectedContents] = useState([])
    const [selectedUsersLoaded, setSelectedUsersLoaded] = useState(false);

    // const contents = [
    //     { id: 1, name: "Introduction" },
    //     { id: 2, name: "Executive Summary" },
    //     { id: 3, name: "Performance Summary" },
    //     { id: 4, name: "Competency Overview" },
    //     { id: 5, name: "Competency Breakout" },
    //     { id: 6, name: "Confirmed Strengths/Opportunities" },
    //     { id: 7, name: "Hidden Strengths/Opportunities" },
    //     { id: 8, name: "Competency Index" },
    //     { id: 9, name: "Processing Your 360-Degree Feedback" },
    //     { id: 10, name: "Next Steps" },
    // ];

    const handleClose = () => setShow(false);
    const initialValues = {
        subjectId: editId,
        reportTitle: '',
        competencies: [],
        contents: [],
    }
    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: validationSchema,
        onSubmit: values => {
            handleSubmit(values);
        }
    });

    const handleSubmit = (values) =>{
        // console.log("valuesvalues",values)
        axios.post(`api/report/create`, values).then(res => {
            setShow(false)
            if(res.data.success){
                Swal.fire(res.data.message, '', 'success').then(result => {
                    formik.resetForm();
                })                
            } 
            else{
                Swal.fire(res.data.message, '', 'error')
            }
        }).catch((error) => {
            setShow(false)
            Swal.fire(error.response.data.message, '', 'error')
        });      
    }
    
    const getCompetencies = async() => {
        await axios.get(`/api/getSubjectCompetencies?assessmentId=${assessmentId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                setCompetencies(result.data)
                setSelectedCompetencies(result.data)
            }
        })
    }

    const getContents = async() => {
        await axios.get(`/api/getSubjectContents?id=${editId}&assessmentId=${assessmentId}`)
        .then(function (response) {
            let result = response.data;
            if(result.success){
                if(result.data){
                    setContents(result.data)
                }
                else{
                    setContents([])
                }
            }
        })
    }
    

    useEffect(() => {
        getCompetencies()
        getContents()
        if(editId > 0){
            setSelectedCompetencies([]);       
            setSelectedContents([]);
            axios.get(`api/subject?id=${editId}`).then(async(res )=> {                
                if(res.data.success && res.data.data){
                    formik.setFieldValue('subjectId', res.data.data.id)
                    formik.setFieldValue('reportTitle', res.data.data.reportTitle === null ? res.data.data.firstName+" "+res.data.data.lastName : res.data.data.reportTitle)
                    
                    let reportCompetencies = res.data.data.reportCompetencies;
                    let reportContents = res.data.data.reportContents;

                    console.log("typeof reportCompetencies", typeof reportCompetencies)
                    console.log("reportCompetencies", reportCompetencies)
                    
                    if (typeof reportCompetencies === 'object' && reportCompetencies !== null) {
                        // console.log("JSON.parse(reportCompetencies)",JSON.parse(reportCompetencies))
                        setSelectedCompetencies(reportCompetencies)
                        formik.setFieldValue('competencies', reportCompetencies);
                    }
                    else if (typeof reportCompetencies === 'string' && reportCompetencies !== null) {
                        // console.log("JSON.parse(reportCompetencies)",JSON.parse(reportCompetencies))
                        setSelectedCompetencies(JSON.parse(reportCompetencies))
                        formik.setFieldValue('competencies', JSON.parse(reportCompetencies));
                    }

                    console.log("typeof reportContents", typeof reportContents)
                    console.log("reportContents", reportContents)

                    if (typeof reportContents === 'object' && reportContents !== null) {
                        // console.log("JSON.parse(reportContents)",JSON.parse(reportContents))
                        setSelectedContents(reportContents)
                        formik.setFieldValue('contents', reportContents);
                    }
                    else if ((typeof reportContents === 'string') && reportContents !== null) {
                        // console.log("JSON.parse(reportContents)",JSON.parse(reportContents))
                        setSelectedContents(JSON.parse(reportContents))
                        formik.setFieldValue('contents', JSON.parse(reportContents));
                    }
                    else{
                        console.log("dasdsssssssssss")
                        setSelectedContents(contents)
                        formik.setFieldValue('contents', contents);
                    }

                    console.log("formik.values",formik.values)
                }
            })
        }
        else{
            setSelectedCompetencies([])
            setSelectedContents([])
            formik.resetForm();
        }
        
    },[show]);

    useEffect(() => {
        setSelectedUsersLoaded(false);
        if (selectedCompetencies.length > 0 && selectedContents.length > 0) {
            formik.setFieldValue('competencies', selectedCompetencies)
            formik.setFieldValue('contents', selectedContents)
            setSelectedUsersLoaded(true);
        }
    }, [selectedCompetencies, selectedContents])

    const handlePopupClose = () => {
        formik.resetForm();
        setSelectedCompetencies([])
        setSelectedContents([])
        handleClose()
    }
    return (
        <Modal show={show} onHide={handlePopupClose}>
            <Modal.Header closeButton>
            <Modal.Title>Edit Report</Modal.Title>
            </Modal.Header>
            <form onSubmit={formik.handleSubmit}>
                <Modal.Body>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Report Title</label>
                                <div className="input-group input-group-merge">
                                    <span className="input-group-text"><i className="bx bx-user"></i></span>
                                    <input name="reportTitle" type="text" className="form-control" placeholder="Report Title" readOnly
                                    value={formik.values.reportTitle} 
                                    // onChange={formik.handleChange} 
                                    // onBlur={formik.handleBlur}
                                    />
                                </div>
                                {formik.touched.reportTitle && formik.errors.reportTitle && (
                                    <div className="text-danger">{formik.errors.reportTitle}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                            <div className="mb-3">
                                <label className="form-label">Report Competencies</label>
                                {selectedUsersLoaded ?
                                    <MultiSelectDropdown 
                                        optionsList={competencies} 
                                        defaultValue={selectedCompetencies} 
                                        formik={formik}
                                    />: 
                                    <>
                                    <MultiSelectDropdown 
                                        optionsList={competencies} 
                                        defaultValue={selectedCompetencies} 
                                        formik={formik}
                                    />
                                    {formik.touched.competencies && formik.errors.competencies && (
                                        <div className="text-danger">{formik.errors.competencies}</div>
                                    )}
                                    </>
                                }
                            </div>
                    </div> 
                    <div className="row">
                            <div className="mb-3">
                                <label className="form-label">Report Contents</label>
                                {selectedUsersLoaded ?
                                    <MultiSelectDropdown 
                                        optionsList={contents} 
                                        defaultValue={selectedContents} 
                                        formik={formik}
                                        contentDropdown={true}
                                    />: 
                                    <>
                                    <MultiSelectDropdown 
                                        optionsList={contents} 
                                        defaultValue={selectedContents} 
                                        formik={formik}
                                        contentDropdown={true}
                                    />
                                    {formik.touched.contents && formik.errors.contents && (
                                        <div className="text-danger">{formik.errors.contents}</div>
                                    )}
                                   
                                    </>
                                }
                            </div>
                    </div> 
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-outline-secondary" data-bs-dismiss="modal" onClick={handlePopupClose}>Close</button>
                    <button type="submit" className="btn btn-primary">Save</button>
                </Modal.Footer>
            </form>
        </Modal>
    )
}
export default Edit;
// Edit.propTypes = {
//     type: PropTypes.string.isRequired,  
// };